export default __webpack_public_path__ + "static/media/case.4c9b2b67.svg";